import {IThiSinhSearchRequest} from "../../model/request/thi-sinh/IThiSinhSearchRequest";
import {apiClient, formatQueryString} from "../apiClient";

export const thiSinhApi = {
    Search: (request: IThiSinhSearchRequest) =>
        apiClient.get(`thi-sinh/search?${formatQueryString(request)}`),
    SelectById: (id: number) => apiClient.get(`thi-sinh/by-id/${id}`),
};
